const OperationType = {
    BEFORE_UPLOAD: 0,
    UPLOADIND: 1,
    UPLOADED: 2,
    GENERATING: 3,
    GENERATED: 4,
    FAILED: 5,
    FILE_LARGE: 6,
    ADDING: 7,
    ADD_FAILED: 8,
    ADDED: 9,
    PUBLISHED: 10
}

export default OperationType;